import { useState } from 'react';
import Sidebar from './Sidebar';
import BottomTabs from './BottomTabs';
import TopBar from './TopBar';
import Corvin from '../corvin/Corvin';

export default function AppShell({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-200 ${sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-60'}`}>
        <TopBar />

        <main className="flex-1 p-4 lg:p-6 pb-20 lg:pb-6">
          {children}
        </main>

        <BottomTabs />
        <Corvin />
      </div>
    </div>
  );
}
